var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2526 2525",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1157.81 420.711H421.606C365.819 420.711 312.317 442.872 272.87 482.319C233.423 521.766 211.262 575.268 211.262 631.055V2103.46C211.262 2159.25 233.423 2212.75 272.87 2252.2C312.317 2291.65 365.819 2313.81 421.606 2313.81H1894.02C1949.8 2313.81 2003.3 2291.65 2042.75 2252.2C2082.2 2212.75 2104.36 2159.25 2104.36 2103.46V1367.26",
    className: "svgStroke",
    strokeWidth: 210.344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1946.6 262.976C1988.44 221.136 2045.19 197.631 2104.36 197.631C2163.53 197.631 2220.28 221.136 2262.12 262.976C2303.96 304.816 2327.46 361.564 2327.46 420.735C2327.46 479.905 2303.96 536.653 2262.12 578.493L1262.98 1577.63L842.293 1682.8L947.465 1262.11L1946.6 262.976Z",
    className: "svgStroke",
    strokeWidth: 210.344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedElement);
export default __webpack_public_path__ + "static/media/selectedElement.4c7d19e2.svg";
export { ForwardRef as ReactComponent };